import { buildQueryParams } from "../utils/buildQueryParams";
import { APIInstance } from "./api.config";

const { api } = new APIInstance({ path: "/v1/roles/" });

export const RolesService = {
  getRoles: (filters = {}) => {
    const params = buildQueryParams(filters);
    return api.get(`?${params.toString()}`);
  },

  getRole: (roleId) => {
    return api.get(`/${roleId}`);
  },

  createRole: (roleDetails) => {
    return api.post("", roleDetails);
  },

  updateRole: (roleId, roleDetails) => {
    return api.put(`/${roleId}`, roleDetails);
  },

  deleteRole: (roleId) => {
    return api.delete(`/${roleId}`);
  },
};
